import { Avatar, Button, Link, Stack, Typography } from '@mui/material';
import { ISubCategory } from 'API/UniversalRequest/universalRequest';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { AccordionArrowBlue, ExternalLink } from 'Images';
import { useState } from 'react';
import { TAB_VALUE_TYPE } from '..';
import { byDepartmentIcons, bySubjectIcons } from '../ParentCategoriesList';
import { useIsDesktop } from 'Hooks';

interface ISubCategoriesHeaderContent {
  getParentTitleById: string;
  parentId: number;
  getSubtitleObj?: ISubCategory;
  tabValue: number;
}

export const SubCategoriesHeaderContent = ({
  getParentTitleById,
  parentId,
  getSubtitleObj,
  tabValue,
}: ISubCategoriesHeaderContent) => {
  const [showExtendedText, setShowExtendedText] = useState(false);
  const dictionary = Dictionary[DICTIONARY.UniversalRequest];
  const isDesktop = useIsDesktop();

  const getIconById = (id: number) =>
    (tabValue === TAB_VALUE_TYPE.SUBJECTS
      ? bySubjectIcons[id]
      : byDepartmentIcons[id]) || bySubjectIcons[1];

  return (
    <>
      <Stack
        direction={'row'}
        width={'auto'}
        maxWidth={'680px'}
        margin={'0 auto'}
        gap={3}
        mb='50px'
      >
        <Stack gap='12px'>
          {getParentTitleById && (
            <Typography component={'h2'} variant={'body3'}>
              {dictionary.subject} <strong>{getParentTitleById}</strong>
            </Typography>
          )}
          {getSubtitleObj && (
            <Typography variant={'body3'} component={'h3'}>
              {dictionary.about} <strong>{getSubtitleObj.title}</strong>
            </Typography>
          )}
          {getSubtitleObj?.description && (
            <Link
              component='button'
              sx={{
                textDecoration: 'underline',
                width: 'auto',
                '&:hover': { textDecoration: 'underline' },
                display: 'flex',
                mt: 3,
                mb: 2,
              }}
              onClick={() => setShowExtendedText(!showExtendedText)}
            >
              <Typography variant={'body3'}>
                {showExtendedText
                  ? dictionary.uploadFile.closeLabel
                  : dictionary.uploadFile.extendLabel}
              </Typography>
              <Avatar
                src={AccordionArrowBlue}
                alt={''}
                sx={{
                  width: '22px',
                  height: '22px',
                  margin: '0 8px',
                  transform: showExtendedText ? 'rotate(180deg)' : undefined,
                }}
              />
            </Link>
          )}
        </Stack>
        {isDesktop && <Avatar alt={''} src={getIconById(parentId)} />}
      </Stack>

      <Stack
        p={isDesktop ? undefined : '0 20px'}
        mt={showExtendedText ? '-80px' : undefined}
      >
        {showExtendedText && (
          <Stack
            sx={{
              margin: '20px auto',
              width: 'auto',
              maxWidth: '680px',
            }}
          >
            <Typography variant={'body3'}>
              {getSubtitleObj?.description}
            </Typography>
            <Button
              sx={{
                width: '138px',
                height: '46px',
                margin: '16px 0',
                borderRadius: '8px',
                bgcolor: 'white',
              }}
              variant='outlined'
              startIcon={
                <Avatar
                  src={ExternalLink}
                  alt={''}
                  sx={{ width: '20px', height: '20px' }}
                />
              }
              href={getSubtitleObj?.descriptionLink}
            >
              <Typography variant={'body5'}>
                {dictionary.uploadFile.externalLinkLabel}
              </Typography>
            </Button>
          </Stack>
        )}
      </Stack>
    </>
  );
};
